import { getAPI } from './api-service'
import { optionsForSurvey } from './service-helper'

export const loadActionsAPI = async ({
  groupName,
  surveyName,
  summaryActions,
  doneOnly,
  aggregate,
  selectedAttributeSegment
}) => {
  const path = selectedAttributeSegment
    ? `/surveys/${surveyName}/groups/${groupName}/actions/attributes/${selectedAttributeSegment.attributeName}/segments/${selectedAttributeSegment.segmentName}`
    : `/surveys/${surveyName}/${groupName}/actions`
  return await getAPI(
    'ResultsAPI',
    path,
    optionsForSurvey({
      aggregate,
      summaryActions: JSON.stringify(summaryActions),
      doneOnly
    })
  )
}
